import {
  DEVICES_LAST_LOCATIONS_FETCH_STARTED,
  DEVICES_LAST_LOCATIONS_FETCH_SUCCEED,
  DEVICES_LAST_LOCATIONS_FETCH_FAILED,
  DEVICES_LAST_LOCATIONS_CLEAR
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchDevicesLastLocations = () => async (dispatch, getState) => {
  try {
    abortController.abort();
    const searchParams = new URLSearchParams();
    const filter = getState().listFilter.device;
    const assignedStatus = filter?.occupied?.value?.[0]?.data?.value;
    const searchParam = filter?.search?.value;
    const deviceTypeValue = filter?.deviceType?.value;
    const projectValue = filter?.project?.value;

    if (searchParam) {
      searchParams.set('filter', searchParam);
      searchParams.set('filterBy', 'title');
    }

    if (deviceTypeValue) {
      const types = deviceTypeValue.map(v => v.data.uid).join(',');

      if (types) {
        searchParams.set('types', types);
      }
    }

    if (projectValue) {
      const ids = projectValue.map(v => v.data.id).join(',');

      if (ids) {
        searchParams.set('projects', ids);
      }
    }

    if (assignedStatus === '1') {
      searchParams.set('occupied', 'only');
      searchParams.set('occupierDetails', 1);
    } else if (assignedStatus === '2') {
      searchParams.set('occupied', 'without');
    } else {
      searchParams.delete('occupied');
      searchParams.set('occupierDetails', 1);
    }

    const url = webPortalApi.buildApiUrl(`device/distinct/locations?${searchParams.toString()}`);
    dispatch({
      type: DEVICES_LAST_LOCATIONS_FETCH_STARTED
    });
    abortController = new AbortController();
    const { signal } = abortController;
    const res = await fetch(url, { ...getRequestOptions(), signal });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }
    if (!res.ok) {
      throw await res.json();
    }

    const devices = await res.json() ?? [];

    const getFilteredDevices = () => {
      const devicesMapped = devices.map(device => ({
        ...device,
        location: device.lastLocation
        // ...filterDevices?.find(d => d.uid === device.uid) ?? {}
      }));

      const filterExist = Object.keys(filter ?? {}).some(k => {
        if (['occupied'].includes(k)) {
          return false;
        }

        return filter[k]?.value?.length;
      });

      if (devices.length && filterExist) {
        const { deviceType, project, search } = filter;
        const filterTypes = deviceType?.value?.map(dt => dt.data.uid);
        const filterProjects = project?.value?.map(p => p.data.id);
        const searchValue = search?.value;

        const filterDevice = device => {
          if (filterTypes?.length) {
            return filterTypes.includes(device.type);
          }

          if (filterProjects?.length) {
            return filterProjects.some(p => device?.projects.includes(p));
          }

          if (searchValue?.length) {
            return device.title?.toLowerCase().includes(searchValue.toLowerCase());
          }

          return false;
        };

        const filteredDevices = devicesMapped.filter(device => {
          const filteredResult = filterDevice(device);

          return filteredResult;
        });

        return filteredDevices;
      }

      return devicesMapped;
    };

    const result = getFilteredDevices();

    dispatch({
      type: DEVICES_LAST_LOCATIONS_FETCH_SUCCEED,
      payload: result
    });
  } catch (e) {
    if (e.name === 'AbortError') {
      return;
    }
    dispatch({
      type: DEVICES_LAST_LOCATIONS_FETCH_FAILED,
      error: e
    });
  }
};

export const clearDevicesLastLocations = () => dispatch => {
  abortController.abort();
  dispatch({
    type: DEVICES_LAST_LOCATIONS_CLEAR
  });
};
